import { getGatewayUrl } from "../utils/get-api-url";

export const postEsignEnvelope = async payload => {
  const apiUrl = getGatewayUrl("esign");
  const fullUrl = `${apiUrl}/esign`;

  const response = await fetch(fullUrl, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify({
      ...payload,
      systemOfOrigin: "1000" //PPQ-5242 enum from ixVocab PaymentClientID)
    })
  });

  const { statusText, ok } = response;
  const text = await response.text();

  if (!ok) throw new Error(text.message || statusText);

  return Promise.resolve();
};
